import * as React from 'react'
import * as styles from './Smile.module.scss'

interface SmileProps {
  width: number
  height: number
  showImage: boolean
}

const Smile = ({width, height, showImage}: SmileProps) => (<div style={{ paddingTop: `calc((100% * ${height}/${width}) - 1px)` }} className={showImage ? styles.NoImgSmile : styles.NoSmileImg}></div>)

export default Smile
